import { Input, Grid, Row, Col, Panel, Accordion } from "react-bootstrap";
import React from "react";
import { t, setLocale } from "../helpers/translate";
import { request } from "../helpers/request";
import { setMicrositeColour } from "../helpers/style";
import LoadingComponent from "./common/LoadingComponent";
import ModalComponent from "./common/ModalComponent";
let config = require("config");

class HowToSubmitClaim extends React.Component {
  constructor(props) {
    setLocale(props.params.lang);
    setMicrositeColour(props.params.microsite);

    sessionStorage.setItem("hide_navbar", true);
    document.body.style.backgroundColor = "white";
    super(props);

    this.state = {
      filesStatus: [],
      claimData: {},
      errors: [],
      submissionId: null,

      showModal: false,
      modalTitle: null,
      modalBody: null,
      activeKey: "1",
    };
    this.handleSelect = this.handleSelect.bind(this);

    this.getAccessToken();
  }

  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  getAccessToken() {
    this.setState({ loading: true });
    jQuery
      .ajax({
        url: `${config.default.auth_base_api}/token/travel/basic`,
        method: "POST",
        data: {
          token: config.default.guest_token,
        },
      })
      .always((response, statusText) => {
        this.setState({ loading: false });
        if (statusText == "success") {
          sessionStorage.setItem(
            "auth",
            "Bearer" + " " + response["access_token"]
          );
        } else {
          this.setState({
            hasError: true,
            modalMessage: t("Unable to retreive token"),
            showErrorModal: true,
          });
        }
      });
  }

  render() {
    const { params } = this.props;
    const micrositeUrl = `${config.default.microsite_url}/${params.microsite}/${params.lang}`;

    return (
      <div className="container how-to-submit-claim">
        <h1 className="title row div-center">{t("How to Submit a Claim")}</h1>

        <p>
          {t("You can use the dedicated")}
          <a
            href="https://studyinsuredportal.ca/a/student"
            target="_blank"
            className="link"
          >
            {t("Student Portal")}
          </a>
          {t("to submit, manage and view claims history.")}
        </p>

        <p>
          {t("Click")}
          <a href={`https://docs.policy-dashboard.com/docs/Microsites/HowToSubmitAClaim_StudentPortal_${t("en")}.pdf`}
            target="_blank"
            className="link"
          >
            {t("here")}
          </a>
          {t("to find step-by-step instructions on submitting a claim through the Student Portal")}.
        </p>

        <h2 className="title row">{t("What is a claim?")}</h2>
        <p>
          {t("If you have received care from any medical facility, you will need to submit a claim. Direct-pay facilities (like hospitals) require you to submit your signed claim form to us—if you don't, they will send you the bill! If you have paid upfront for your medical service(s), this is the only way to get reimbursed!")}
        </p>
        <p>
          {t("Note that you will only get money back for covered expenses, such as hospital or paramedic fees. These will be specified in your insurance policy.")}
        </p>
        <p>{t("Below is a three-step guide to submitting your claim.")}</p>
        <p>
          {t("Haven't seen the doctor yet? Use our")}
          <a href={`${micrositeUrl}/health-services`} className="link">
            {t("Find a Doctor")}
          </a>
          {t("tool to avoid paying out-of-pocket medical fees.")}
        </p>

        <h2 className="title row">{t("How to submit a claim?")}</h2>
        <p>{t("Below is a three-step guide to submitting your claim.")}</p>
        <Accordion
          activeKey={this.state.activeKey}
          onSelect={this.handleSelect}
        >
          <Panel
            eventKey="1"
            header={t("1. Gather all pertinent information.")}
          >
            <p>
              {t("Ask for a receipt every time you pay for a medical service.")}{" "}
              <a
                href={`${micrositeUrl}/download-claim-form`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("Locate the claim form you need here.")}
              </a>
            </p>
            <h5 className="tip">{t("Tip:")}</h5>
            <ul>
              <li>
                {t("Keep your receipts in a safe place! You will need to include these with your claim form if you want to be reimbursed.")}
              </li>
            </ul>
          </Panel>
          <Panel
            eventKey="2"
            header={t("2. Complete the form accurately and honestly.")}
          >
            <p>
              {t("Fill out the claim form, making sure to include as much detail as possible—especially if the situation was unusual. Include original copies of all invoices and receipts. If you are submitting your claim electronically, make copies and keep the originals in a safe place. Your insurer may ask to see them at a later date!")}
            </p>
            <h5 className="tip">{t("Tip:")}</h5>
            <ul>
              <li>
                {t("Make sure your contact information is current in case your insurance provider needs to contact you.")}
              </li>
              <li>
                {t("Don't skip any questions! The insurance company will not process a claim that is incomplete.")}
              </li>
              <li>
                {t("If you are unsure about how to answer a question, contact your insurance provider.")}
              </li>
              <li>
                {t("Don't forget to sign the form! A claim form without a signature will not be processed.")}
              </li>
              <li>
                {t("Please make sure you provide accurate and complete payment information on the Claim Form. Double-check the payee name, address and account details for Canadian banks or foreign accounts to ensure you don’t experience delays in receiving your payment.")}
              </li>
            </ul>
          </Panel>
          <Panel
            eventKey="3"
            header={t("3. Submit your claim and wait for your payment to arrive, if your claim is eligible.")}
          >
            <div>
              <span>
                <strong>{t("Online")}</strong> -{" "}
                {t("Filing a claim is quick and easy with MSH's new and improved online claim submission!")}
              </span>

              <div className="clear"></div>

              <span>
                <strong>{t("Email")}</strong> - {t("Email your documents to:")}
                <a href="mailto:studentclaims@studyinsured.com">
                  studentclaims@studyinsured.com
                </a>
                .
              </span>

              <div className="clear"></div>

              <span>
                <strong>{t("Post")}</strong> -{" "}
                {t("Mail your original documentation to:")}
                <br />
                {t("StudyInsured™ – Claims Administration")}
                <br />
                {t("150 King St West, Suite 602,")}
                <br />
                {t("Toronto, ON M5H 1J9")}
              </span>

              <div className="clear"></div>

              <span>
                <strong>{t("Fax")}</strong> -{" "}
                {t("Send your documents to MSH via fax at")}
                <br />
                {t("1-416-730-1878.")}
              </span>

              <div className="clear"></div>

              <h5 className="tip">{t("Tip:")}</h5>

              <ul>
                <li>
                  {t("No matter how you decide to submit your claim, don’t forget your supporting documentation!")}
                </li>
              </ul>
            </div>
          </Panel>
        </Accordion>
      </div>
    );
  }
}
HowToSubmitClaim.displayName = "HowToSubmitClaim";
export default HowToSubmitClaim;



// WEBPACK FOOTER //
// ./src/components/HowToSubmitClaim.js